import simulatorTrainingRoutes from 'modules/simulatorTrainings/common/routing/routes'

const routes = {
  root: `${simulatorTrainingRoutes.studentSL}/training/details`,
}

export default routes
